import { Component, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

library.add(faLink, faLinkedinIn, faWhatsapp)

@Component
export default class SocialFeed extends Vue {
	podcasts = [] as Array<any>
	blogPosts = [] as Array<any>

	loadPodcasts() {
		fetch('https://anchor.fm/s/d95ff364/podcast/rss')
			.then((response) => response.text())
			.then((str) =>
				new window.DOMParser().parseFromString(str, 'text/xml'),
			)
			.then((data) => {
				const items = data.querySelectorAll('item')
				items.forEach((item) => {
					const podcast = {
						title: item.getElementsByTagName('title')[0]
							.textContent,
						desc: item.getElementsByTagName('description')[0]
							.textContent,
						episode:
							item.getElementsByTagName('itunes:episode')[0]
								.textContent,
						season: item.getElementsByTagName('itunes:season')[0]
							.textContent,
						image: item
							.getElementsByTagName('itunes:image')[0]
							.getAttribute('href'),
						duration:
							item.getElementsByTagName('itunes:duration')[0]
								.textContent,
						link: item.getElementsByTagName('link')[0].textContent,
						audio: {
							url: item
								.getElementsByTagName('enclosure')[0]
								.getAttribute('url'),
							type: item
								.getElementsByTagName('enclosure')[0]
								.getAttribute('type'),
							length: item
								.getElementsByTagName('enclosure')[0]
								.getAttribute('length'),
						},
					}

					this.podcasts.push(podcast)
				})
			})
	}

	loadBlogPosts() {
		fetch(
			'https://locatelliadv.com.br/wp-json/wp/v2/posts?_embed&per_page=4',
		)
			.then((response) => response.json())
			.then((data) => {
				data.forEach((item) => {
					const post = {
						text: item.excerpt.rendered,
						link: item.link,
						title: item.title.rendered,
						image:
							item._embedded['wp:featuredmedia'].length > 0
								? item._embedded['wp:featuredmedia'][0]
										.source_url
								: null,
					}

					this.blogPosts.push(post)
				})
			})
	}

	mounted() {
		this.loadPodcasts()
		this.loadBlogPosts()
	}

	copyUrl(url) {
		navigator.clipboard.writeText(url)
		this.$bvToast.toast('Link Copiado!', {
			title: 'Link Copiado!',
			variant: 'success',
			solid: true,
			toaster: 'b-toaster-top-center',
		})
	}

	openLink(url) {
		window.open(url, '_blank')
	}

	get mergedSocialPosts() {
		if (this.blogPosts.length < 3 || this.podcasts.length < 3) return []

		const merged = [] as Array<any>
		for (let i in [1, 2, 3]) {
			merged.push(this.blogPosts[i])
			merged.push(this.podcasts[i])
		}

		return merged
	}

	get isSmallScreen() {
		return window.innerWidth <= 576
	}
}
